/**
 * MyParcelsPage — Page dédiée « Mes parcelles suivies ».
 *
 * Wrapper standalone du composant ProDashboard, accessible via /parcelles
 * depuis le Dashboard principal (bouton dédié).
 */
import { useNavigate } from "react-router-dom";
import ProDashboard from "@/components/ProDashboard";
import { useEffect, useState } from "react";
import { getMyDashboard } from "@/lib/api";

export default function MyParcelsPage() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [isPro, setIsPro] = useState(false);

  useEffect(() => {
    getMyDashboard()
      .then(res => {
        setUser(res.data?.user || null);
        setIsPro(!!res.data?.is_pro);
      })
      .catch(() => {});
  }, []);

  const handlePhyto = (parcel) => {
    if (parcel?.parcel_id) {
      navigate(`/carnet/${parcel.parcel_id}?tab=phyto`);
    }
  };

  return (
    <div className="h-screen w-full bg-white" data-testid="my-parcels-page">
      <ProDashboard
        user={user}
        onBack={() => navigate("/dashboard")}
        onPhyto={handlePhyto}
        isPro={isPro}
      />
    </div>
  );
}
